<label>
  <ng-content></ng-content>
  {{ showAsterisk ? '*' : '' }}
</label>
